export enum PolicyComponentCreationModeTypes  {
    FROM_SCRATCH = "FROM_SCRATCH",
    FROM_COPY_COMPONENT = "FROM_COPY_COMPONENT"
}